__turbopack_context__.v({
  "activeLabel": "SwatchCard-module__NiWWPa__activeLabel",
  "badge": "SwatchCard-module__NiWWPa__badge",
  "grid": "SwatchCard-module__NiWWPa__grid",
  "swatchButton": "SwatchCard-module__NiWWPa__swatchButton",
});
